import { render, staticRenderFns } from "./GearInchTable.vue?vue&type=template&id=83af7ab0&scoped=true&"
import script from "./GearInchTable.vue?vue&type=script&lang=js&"
export * from "./GearInchTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83af7ab0",
  null
  
)

export default component.exports